// src/shared/utils/formatters.js
export const formatDate = (date) => {
    return new Date(date).toLocaleDateString('en-US', {
        weekday: 'long',
        year: 'numeric',
        month: 'long',
        day: 'numeric'
    });
};

export const formatDuration = (seconds) => {
    const hours = Math.floor(seconds / 3600);
    const minutes = Math.floor((seconds % 3600) / 60);
    const remainingSeconds = seconds % 60;

    return `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}:${remainingSeconds.toString().padStart(2, '0')}`;
};

export const penaltyDaysLate = (penaltyFactor) => {
    if (penaltyFactor === undefined || penaltyFactor === null || penaltyFactor >= 1.0) return null;
    if (penaltyFactor <= 0.0) return '5+ days late';
    const brackets = Math.round((1.0 - penaltyFactor) / 0.2);
    return `${brackets} day${brackets !== 1 ? 's' : ''} late`;
};

export const calculatePace = (duration, distance, activityType) => {
    if (!duration || !distance) return '0:00';

    const paceInSeconds = duration / distance;
    const minutes = Math.floor(paceInSeconds / 60);
    const seconds = Math.floor(paceInSeconds % 60);

    return `${minutes}:${seconds.toString().padStart(2, '0')}`;
};

/**
 * Returns a structured breakdown of how points were calculated for an activity.
 * Mirrors the backend calculate_points() logic in add_activity.py.
 */
export const getPointsBreakdown = (activity) => {
    const type = activity.activityType?.toLowerCase() || '';
    const distance = parseFloat(activity.distance) || 0;
    const elevation = parseFloat(activity.elevation) || 0;
    const calories = parseFloat(activity.calories) || 0;
    const penaltyFactor = activity.penaltyFactor ?? 1.0;
    const effectivePoints = parseFloat(activity.points) || 0;
    const rawPoints = parseFloat(activity.rawPoints ?? activity.points) || 0;

    let distancePoints = 0;
    let formulaLine = '';

    switch (type) {
        case 'running':
            distancePoints = distance + elevation / 100;
            formulaLine = elevation > 0
                ? `${distance.toFixed(1)} km + ${elevation.toFixed(0)} m ÷ 100`
                : `${distance.toFixed(1)} km`;
            break;
        case 'cycling':
            distancePoints = distance / 4 + elevation / 200;
            formulaLine = elevation > 0
                ? `${distance.toFixed(1)} km ÷ 4 + ${elevation.toFixed(0)} m ÷ 200`
                : `${distance.toFixed(1)} km ÷ 4`;
            break;
        case 'hiking':
            distancePoints = distance * 0.5 + elevation / 100;
            formulaLine = elevation > 0
                ? `${distance.toFixed(1)} km × 0.5 + ${elevation.toFixed(0)} m ÷ 100`
                : `${distance.toFixed(1)} km × 0.5`;
            break;
        case 'swimming':
            distancePoints = distance * 4;
            formulaLine = `${distance.toFixed(2)} km × 4`;
            break;
        case 'football':
        case 'badminton':
        default:
            distancePoints = distance;
            formulaLine = `${distance.toFixed(1)} km`;
            break;
    }

    const caloriesPoints = calories / 100;
    const usedCalories = calories > 0 && caloriesPoints > distancePoints;

    return {
        activityType: type.charAt(0).toUpperCase() + type.slice(1),
        distancePoints: Math.round(distancePoints * 100) / 100,
        caloriesPoints: Math.round(caloriesPoints * 100) / 100,
        usedCalories,
        rawPoints,
        penaltyFactor,
        effectivePoints,
        formulaLine,
    };
};